module.exports = __webpack_public_path__ + "static/media/003_powerControlCenter.9066880f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/google/003_powerControlCenter.png
// module id = 461
// module chunks = 0